export const FEATURE_FLAGS_API_HOST = process.env.NEXT_PUBLIC_FEATURE_FLAGS_API_HOST

export const resolveFeatureFlagsClientKey = (): string | undefined => {
  const appEnv = process.env.NEXT_PUBLIC_APP_ENV

  if (appEnv === 'prod') {
    return process.env.NEXT_PUBLIC_FEATURE_FLAGS_CLIENT_KEY_PROD
  }

  if (appEnv === 'staging') {
    return process.env.NEXT_PUBLIC_FEATURE_FLAGS_CLIENT_KEY_STAGING
  }

  return process.env.NEXT_PUBLIC_FEATURE_FLAGS_CLIENT_KEY_DEV
}

export const isFeatureFlagsConfigured = (): boolean => Boolean(resolveFeatureFlagsClientKey())
